var SCM = SCM || {};

(function (ns, $) {
    
    ns.init = function (fieldSelector, outerScopeSelector) {
        const $scope = $(outerScopeSelector);
        const showPasswordSelector = '.js-show-password';
        const hidePasswordSelector = '.js-hide-password';

        $scope.on('click', showPasswordSelector, function () {
            $scope.find(fieldSelector).each(function () {
                const $this = $(this);
                const $newInput = $this.clone();
                $newInput.attr('type', 'text');
                $newInput.attr('autocomplete', 'off');
                $newInput.attr('value', $this.val());

                $this.after($newInput);
                $this.remove();
            });

            $(this).addClass('hide');
            $(hidePasswordSelector).removeClass('hide');
        });

        $scope.on('click', hidePasswordSelector, function () {
            $scope.find(fieldSelector).each(function () {
                const $this = $(this);
                const $newInput = $this.clone();
                $newInput.attr('type', 'password');
                $newInput.removeAttr('autocomplete');
                $newInput.attr('value', $this.val());

                $this.after($newInput);
                $this.remove();
            });


            $(this).addClass('hide');
            $(showPasswordSelector).removeClass('hide');
        });
    };
    
})(SCM.PasswordDisplayToggle = SCM.PasswordDisplayToggle || {}, jQuery);